import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import CreditCardModal from '@/components/modalCreditCard/modalCreditCard'
import ModalPse from '@/components/modalPse/modalPse'
import Loading from '@/components/loading/loading'
import ModalWompi from '@/components/modalWompi/modalWompi';
import Multiselect from "@/components/multiselect/multiselect";

@Component({
  components: {
    CreditCardModal,
    ModalPse,
    Loading,
    ModalWompi,
    Multiselect
  }
})
export default class CheckoutPayment extends Vue {
  @Prop({ default: () => [] }) validate!: Array<any>;

  // Getters
  @Getter getCountry;
  @Getter getCreditCards;
  @Getter getIsTestUser;
  @Getter getCurrentPaymentMethod;
  @Getter getCart;
  @Getter getPseInformation;
  @Getter getCity;
  @Getter getUser;

  // Actions
  @Action action_activateCartCoupon;
  @Action action_deactivateCartCoupon;
  @Action action_validatePaymentMethod;
  @Action action_deleteCreditCard;
  @Action action_putUser;
  @Action action_updateNormalUserInformation;

  // Mutations
  @Mutation CURRENT_PAYMENT_METHOD;

  height = null;
  // metodo usando por el usurio
  payment = {
    type: "",
    value: null,
    card: null
  };
  userForm = {
    first_name: "",
    last_name: "",
    document_type: "cc",
    document_number: "",
    cellphone: "",
    email: ""
  };
  optionsType = ["cc", "ce"];
  docOptions = [{ id: "cc", label: "CC" }, { id: "c", label: "Casad@" }];
  pse_info = null;
  deleteCard = null;
  idNumber = "";
  documentType = "";

  // modal
  isModalCard = false;
  isActivePse = false;
  initialSetup = true;
  showPaymentMethods = false;
  showWompiModal = false;
  validationCard = null;

  // Atributos cupón
  couponIsDisabled = false;
  isActive = true;
  isCoupon = false;
  couponText = "";
  error = "";
  loading = false;

  attemptedCardValidations = [];

  get isMx() {
    return this.getCity.id === 5 ? true : false;
  }

  get getCheck() {
    return this.payment.type && this.payment.value;
  }

  get getIsCard() {
    return this.getCountry
      ? this.getCountry.available_payment_methods_for_delivery.includes("CREDIT_CARD")
      : false;
  }

  get getIsPse() {
    return this.getCountry
      ? this.getCountry.available_payment_methods_for_delivery.includes("PSE")
      : false;
  }

  get getIsCash() {
    return this.getCountry
      ? this.getCountry.available_payment_methods_for_delivery.includes("CASH")
      : false;
  }

  get getIsWompiLink() {
    return this.getCountry
      ? this.getCountry.available_payment_methods_for_delivery.includes("PAYMENT_LINK")
      : false;
  }

  get getAllowedCards() {
    if (this.getCreditCards && Object.keys(this.getCreditCards).length > 0) {
      return this.isMx
        ? this.getCreditCards.filter(x => x.processor == "conekta")
        : this.getCreditCards.filter(x => x.processor == "wompi");
    }
    return [];
  }

  get getError() {
    let myError = this.validate.filter(item => {
      return item.type === "Método de pago";
    });
    return myError.length !== 0 && !this.payment.value ? myError[0] : false;
  }

  get getSelectedPaymentTypeLabel() {
    if (this.payment.type === "cash") return "Efectivo";
    else if (this.payment.type === "pse") return "PSE";
    else if (this.payment.type === "payment_link") return "Link de Pago";
    else if (this.payment.type === "credit_card")
      return `****${this.payment.card.credit_card_number}`;
  }

  get getShowHideArrow() {
    if (this.showPaymentMethods) {
      return "ion-ios-arrow-up";
    }
    return "ion-ios-arrow-down";
  }

  mounted() {
    this.setCoupon();
    this.setDefaultPaymentMethod();
  }

  @Watch("getCart", { deep: true })
  onCartChange() {
    if (
      this.getCart &&
      this.getCart.coupon_applied &&
      this.getCart.coupon_data &&
      this.getCart.coupon_data.code
    ) {
      this.couponText = this.getCart.coupon_data.code;
    } else {
      this.couponText = "";
    }
  }

  private setDefaultPaymentMethod() {
    if (!this.getCurrentPaymentMethod) {
      const defaultCard = this.getDefaultCard();
      if (defaultCard && defaultCard.id) {
        this._validateCard(defaultCard);
        this._setPayment("credit_card", defaultCard.id, defaultCard);
      } else if (this.getPseInformation) {
        this._setPayment("pse");
      } else {
        this._setPayment("cash", "default");
      }
    } else if (this.getCurrentPaymentMethod) {
      const paymentMethod = this.getCurrentPaymentMethod;
      if (paymentMethod.card && paymentMethod.card.id) {
        const index = this.attemptedCardValidations.findIndex(
          cardId => cardId === paymentMethod.card.id
        );
        if (index !== -1) {
          this.CURRENT_PAYMENT_METHOD(null);
          this.setDefaultPaymentMethod();
        } else {
          this._validateCard(paymentMethod.card);
          this._setPayment(paymentMethod.type, paymentMethod.value, paymentMethod.card);
        }
      } else if (
        paymentMethod.type &&
        paymentMethod.type.length &&
        paymentMethod.value &&
        paymentMethod.value.length
      ) {
        this._setPayment(paymentMethod.type, paymentMethod.value);
      } else {
        this._setPayment("cash", "default");
      }
    }
    this.onChangePaymentMethod();
  }

  private getDefaultCard() {
    let res = null;
    for (let i = 0; i < this.getAllowedCards.length && !res; i++) {
      const card = this.getAllowedCards[i];
      const index = this.attemptedCardValidations.findIndex(cardId => cardId === card.id);
      if (card.migrate && !card.is_black_listed && card.payment_source_id && index === -1) {
        res = card;
      }
    }
    return res;
  }

  @Watch("pse_info")
  onPseInfo(val) {
    this.$emit("pseInfo", val);
  }

  async _setPayment(type, value = null, card = null) {
    this.loading = true;
    if (type === "pse") {
      this.isActivePse = true;
    }
    const payment = {
      type,
      value,
      card
    };
    if (card && card.is_womp_allowed && !card.migrate) {
      this.validationCard = card;
      this.showWompiModal = true;
    }
    this.payment = { ...this.payment, ...payment };
    this.activateDaviviendaCoupon();
    this.$emit("payment", this.payment);
    this.onChangePaymentMethod();
    this.loading = false;
  }

  _iconCard(value) {
    let icon = "ceu-icon-visacard";
    switch (value) {
      case "MASTERCARD":
        icon = "ceu-icon-mastercard";
        break;
      case "AMEX":
        icon = "ceu-icon-american-express";
        break;
    }
    return icon;
  }

  _toggleModalCard() {
    this.isModalCard = !this.isModalCard;
  }

  _validateCard(card) {
    let title = "";
    let text = "";
    if (!card.is_womp_allowed && !this.isMx) {
      title = "¡Aviso importante!";
      text =
        "Dado a nuestro crecimiento en LATAM hemos" +
        " cambiado nuestro proveedor de pagos y por seguridad no podemos migrar" +
        " la información de tus tarjetas de crédito. Por favor agregala nuevamente, te pedimos mil disculpas";
    } else if (!card.payment_source_id) {
      this.validationCard = card;
      this.showWompiModal = true;
    }
    if (title.length && text.length) {
      this.$swal({
        title: title,
        text: text
      });
    }
  }

  _setDocumentOption(docOption) {
      this.documentType = docOption;
  }

  _cancelPse() {
    const payment = {
      type: "",
      value: null,
      card: null
    };
    this.payment = payment;
    this.setDefaultPaymentMethod();
    this.$emit("payment", null);
    this.isActivePse = false;
  }

  onChangePaymentMethod() {
    this.showPaymentMethods = !this.showPaymentMethods;
  }

  @Watch("getCart", { deep: true })
  setCoupon() {
    if (
      this.getCart &&
      this.getCart.coupon_applied &&
      this.getCart.coupon_data &&
      this.getCart.coupon_data.code &&
      this.getCart.coupon_data.code.length
    ) {
      this.couponText = this.getCart.coupon_data.code;
      this.couponIsDisabled = true;
    }
  }

  async _checkCoupon() {
    this.loading = true;
    try {
      if (this.couponText.length) {
        const data = {
          coupon: {
            code: this.couponText
          }
        };
        if (this.couponIsDisabled) {
          await this.action_deactivateCartCoupon(data);
          this.couponIsDisabled = false;
          this.couponText = "";
          this.$emit("updateCoupon", data);
        } else {
          let isDaviCoupon = await this.isDaviviendaCouponValid();
          if (
            (this.couponText === "Davivienda" && isDaviCoupon) ||
            this.couponText !== "Davivienda"
          ) {
            await this.action_activateCartCoupon(data);
            this.couponIsDisabled = true;
            this.$emit("updateCoupon", data);
          }
        }
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        this.error = error && error.response && error.response.data && error.response.data.message;
        if (error.response.status) {
          const status = error && error.response && error.response.status;
          if (status >= 400) {
            this.$emit("close-modal");
            this.$swal({
              title: "Error al validar el cupónn...",
              text: this.error
            });
          }
        }
      }
    }
    this.loading = false;
    (this as any).$ga.event("Checkout", "Cupón", "Cupón");
  }

  isSelectedCard(currentCard) {
    if (this.payment.card && this.payment.card.id) {
      return currentCard.id === this.payment.card.id;
    }
  }

  _onSavePse(info) {
    if (info) {
      this.pse_info = info;
      this.isActivePse = false;
    }
  }

  _onClosePse() {
    this.isActivePse = false;
    this._setPayment("cash", "default");
  }

  async isDaviviendaCouponValid() {
    let response = false;
    try {
      if (this.payment && this.payment.card) {
        response = await this.action_validatePaymentMethod(this.payment.card);
      }
    } catch (error) {
      this.$swal({
        title: "Error",
        text: "¡Ups! Hubo un error de nuestra parte." + error
      });
    }
    return response;
  }

  async postId() {
    this.userForm.document_number = this.idNumber;
    this.userForm.document_type = this.documentType;
    const { document_type, document_number } = this.userForm;
    const payload = { normal_user: { document_type, document_number } };
    await this.action_updateNormalUserInformation(payload);
  }

  async activateDaviviendaCoupon() {
    const currentCoupon = this.getCart.coupon_data;
    if (this.payment) {
      const isValid = await this.action_validatePaymentMethod(this.payment.card);
      if (
        (isValid && currentCoupon) ||
        (!isValid && currentCoupon && currentCoupon.code === "Davivienda")
      ) {
        this.couponIsDisabled = true;
        await this._checkCoupon();
      }
      if (isValid) {
        this.couponText = "Davivienda";
        this.couponIsDisabled = false;
        await this._checkCoupon();
      }
    }
  }

  _wompiModalCancel(card) {
    if (card && card.id) {
      const index = this.attemptedCardValidations.findIndex(cardId => cardId === card.id);
      if (index === -1) {
        this.attemptedCardValidations.push(card.id);
      }
    }
    this.deleteCard = null;
    this.showWompiModal = false;
    this.setDefaultPaymentMethod();
  }

  _wompiModalSucess() {
    this.showWompiModal = false;
    const index = this.attemptedCardValidations.findIndex(cardId => cardId === this.deleteCard.id);
    if (index !== -1) {
      this.attemptedCardValidations.splice(index, 1);
    }
    this.deleteCard = null;
    this.$router.go(0);
  }
}
